module.exports = __webpack_public_path__ + "static/media/M.9adbfbb8.jpg";